import { useState, FC } from 'react'
import classNames from 'classnames'

import Card from './Card'
import styles from './Agenda.module.scss'

import { TAgenda } from 'types'
import { agendaData } from 'resources'
import { SectionLayout } from 'components'

type AgendaProps = {
  isEdition?: boolean
  comingSoon?: boolean
  addToRefs?: (el: HTMLDivElement) => void
}

const Agenda: FC<AgendaProps> = ({ addToRefs, comingSoon = false, isEdition = false }) => {
  const [activeStep, setActiveStep] = useState(0)

  const activeEventData = agendaData[isEdition ? '2024' : '2025'] as TAgenda[]

  const agendaStart = activeEventData.filter(item => item.type === 'start')
  const agendaTrackOne = activeEventData.filter(item => item.type === 'trackOne')
  const agendaTrackTwo = activeEventData.filter(item => item.type === 'trackTwo')
  const agendaWorkshops = activeEventData.filter(item => item.type === 'workshops')
  const agendaEnd = activeEventData.filter(item => item.type === 'end')

  const trackList: { [key: number]: any[] } = {
    0: agendaTrackOne,
    1: agendaTrackTwo,
    2: agendaWorkshops,
  }

  const activeTrack = trackList[activeStep]
  const renderStartList = agendaStart.map(item => <Card key={item.id} data={item} />)
  const renderEndList = agendaEnd.map(item => <Card key={item.id} data={item} />)
  const renderTrackList = activeTrack.map(item => <Card key={item.id} data={item} isTrackList />)

  return (
    <SectionLayout id='AGENDA' addToRefs={addToRefs}>
      <div className='container'>
        <h1 className={styles.wrapper__title}>Agenda</h1>
        {comingSoon ? (
          <div className={styles.soon} />
        ) : (
          <>
            <div className={styles.content}>
              {renderStartList}
              <div className={styles.navigation}>
                <div
                  style={{ transform: `translateX(${activeStep * 100}%)` }}
                  className={styles.navigation__item_spiner}
                />
                <div
                  onClick={() => setActiveStep(0)}
                  className={classNames(styles.navigation__item, {
                    [styles.navigation__item_active]: activeStep === 0,
                  })}
                >
                  <p>Track 1</p>
                  <p>
                    <span>Classroom</span> 208E
                  </p>
                </div>
                <div
                  onClick={() => setActiveStep(1)}
                  className={classNames(styles.navigation__item, {
                    [styles.navigation__item_active]: activeStep === 1,
                  })}
                >
                  <p>Track 2</p>
                  <p>
                    <span>Classroom</span> 207E
                  </p>
                </div>
                <div
                  onClick={() => setActiveStep(2)}
                  className={classNames(styles.navigation__item, {
                    [styles.navigation__item_active]: activeStep === 2,
                  })}
                >
                  <p>Workshops</p>
                  <p>
                    <span>Classroom</span> 416W
                  </p>
                </div>
              </div>
              {renderTrackList}
              {renderEndList}
            </div>
          </>
        )}
      </div>
    </SectionLayout>
  )
}

export default Agenda
